import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import searchReducer from "./features/search/searchReducer";
import movieReducer from "./features/movie/movieReducer";
import likesReducer from "./features/likes/likesReducer";
import wishlistReducer from "./features/wishlist/wishlistReducer";
import watchlistReducer from "./features/watchlist/watchlistReducer";

const rootReducer = combineReducers({
  search: searchReducer,
  movie: movieReducer,
  likes: likesReducer,
  wishlist: wishlistReducer,
  watchlist: watchlistReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
